import { Th, Thead, Tr } from '@chakra-ui/react';
import { t } from '@/i18n';

const labels = [
  { label: t('pages.access_control_permission_types.components.permission_table_header.column_created_at') },
  { label: t('pages.access_control_permission_types.components.permission_table_header.column_name') },
  { label: t('pages.access_control_permission_types.components.permission_table_header.column_actions') },
];

export const AccessControlPermissionTypesTableHeader = () => {
  return (
    <Thead
      sx={{
        '& th': {
          py: '8px',
        },
      }}
    >
      <Tr>
        {labels.map(({ label }) => (
          <Th key={label}>{label}</Th>
        ))}
      </Tr>
    </Thead>
  );
};
